module.exports = __webpack_public_path__ + "static/media/digital_experience.d555c807.webp";